import {
  dentureRepairItemSchema,
  getBaseProductSchema,
  ItemTypeEnum,
  ProductTypeEnum,
  type DentureRepairProduct,
} from "@jasper/client-models";
import z from "zod";
import {
  TeethSelectionEnum,
  type ProductWorkflowConfiguration,
} from "./ProductWorkflowConfiguration";
import { StepKeysEnum } from "../../steps/types";
import { ArchStep } from "./constants";

export type DentureRepairStepKey = typeof StepKeysEnum.arch;

const dentureRepairArchesSchema = z.object({
  items: z.array(dentureRepairItemSchema).min(1),
});

export const DentureRepairWorkflowConfiguration: ProductWorkflowConfiguration<
  DentureRepairProduct,
  DentureRepairStepKey
> = {
  productType: ProductTypeEnum.dentureRepair,
  itemType: ItemTypeEnum.dentureRepair,
  steps: [new ArchStep()],
  teethSelection: TeethSelectionEnum.ARCH,
  isBulkSupported: true,

  isValidProduct(product) {
    return getBaseProductSchema({
      itemSchema: dentureRepairItemSchema,
    }).safeParse(product).success;
  },

  getCompletedSteps(product) {
    return dentureRepairArchesSchema.safeParse(product).success
      ? [StepKeysEnum.arch]
      : [];
  },
};
